export default function () {
  return {
    userInfo: {},
    nodes: [],
    nodeId: null,
    defaultNode: null,
    organization: [],
    userRoles: [],
    isLoaded: false,
    apiClient: null,
    isDisable: false, // パンクズメニュー disableフラグ
  }
}
